function TermsPrompteX() {
  return (
    <iframe
      src="/assets/promptex-legal.pdf"
      title="Termos Legais PrompteX"
      style={{ width: '100%', height: '100vh', border: 'none', display: 'block' }}
    />
  );
}

export default TermsPrompteX;
